module.exports = __webpack_public_path__ + "img/Image_6.370aa88b.png";